import { User } from "../micro-services/user/models/user";
import { Abonnement } from "./abonnement";

export class Payment {
   public id : number;
   public client : User;
   public montantPaye : number;
   public abonnement : Abonnement;
   public datePaiement : Date;
   public clientId : string;
   public coachId : string;
   public paymentMethod : string;
   public coach : User;
   public isExpanded : Boolean = false;
   public showListBtnBox : Boolean = false;
   public type : Number = 0;
}
